import React from "react";
import { getSEOData } from "../../../global/utils/constants/seoConfig";
import SEO from "../../../global/components/SEO/SEO";
import "../Style/warrantypolicy.css";
import WarrantyPolicyBanner from "../Components/WarrantyPolicyBanner";
import WarrantyInfo from "../Components/WarrantyInfo";

const WarrantyPolicy = () => {
  const seoData = getSEOData("/warrantypolicy");

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        type="website"
      />
      <WarrantyPolicyBanner />
      <WarrantyInfo />
    </>
  );
};

export default WarrantyPolicy;
